import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled, useTheme }, "@mui/material/Box": Box, "@mui/material/Drawer": MuiDrawer, "@mui/material/AppBar": MuiAppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/List": List, "@mui/material/CssBaseline": CssBaseline, "@mui/material/Typography": Typography, "@mui/material/Divider": Divider, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/ChevronLeft": ChevronLeftIcon, "@mui/icons-material/ChevronRight": ChevronRightIcon, "@mui/material/ListItem": ListItem, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/MoveToInbox": InboxIcon, "@mui/icons-material/Mail": MailIcon } } });
export default ClientProvider;
